import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import SidebarComponent from './ui/sidebar/SidebarComponent';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexWrap: 'nowrap',
  },
  mainBlock: {
    width: '100%',
    height: '100%',
    overflow: 'scroll',
  },
}));

const Layout = ({ navigations, role, renderHeader, children, product }) => {
  const classes = useStyles();
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const [currentRoute, setCurrentRoute] = useState(location.pathname);

  useEffect(() => {
    setExpanded(false);
  }, [location.pathname]);

  const toggleExpand = () => setExpanded(!expanded);

  return (
    <Box className={classes.container}>
      <SidebarComponent
        expanded={expanded}
        selectedItem={currentRoute}
        onChange={setCurrentRoute}
        content={navigations}
        toggleMenu={toggleExpand}
        role={role}
        product={product}
      />
      <Box className={classes.mainBlock} id="scroll-container">
        {renderHeader({ toggleMenu: toggleExpand })}
        <Box padding={{ xs: 2, md: 3 }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default Layout;
